import { userSlice } from "./slice";

export * as userAsyncThunks from "./asyncThunks";
export * as userSelectors from "./selector";
export const userActions = userSlice.actions;
export const userReducer = userSlice.reducer;
